import get from "lodash/get";
import set from "lodash/set";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import Api from "apps/edit_details/util/web";


// actions
// -----------------------------------------------------------------------------

export const SET_INITIAL_STATE = "EDIT_DETAILS.SET_INITIAL_STATE";
export const SET_ACTIVE_FORM = "EDIT_DETAILS.SET_ACTIVE_FORM";
export const CANCEL_ACTIVE_FORM = "EDIT_DETAILS.CANCEL_ACTIVE_FORM";
export const SAVE_FORM = "EDIT_DETAILS.SAVE_FORM";
export const SAVE_FORM_SUCCESS = "EDIT_DETAILS.SAVE_FORM_SUCCESS";
export const SAVE_FORM_ERROR = "EDIT_DETAILS.SAVE_FORM_ERROR";
export const USERNAME_SEARCH = "EDIT_DETAILS.USERNAME_SEARCH";
export const USERNAME_SEARCH_SUCCESS = "EDIT_DETAILS.USERNAME_SEARCH_SUCCESS";
export const USERNAME_SEARCH_ERROR = "EDIT_DETAILS.USERNAME_SEARCH_ERROR";
export const SAVE_PRONOUNS = "EDIT_DETAILS.SAVE_PRONOUNS";
export const SAVE_PRONOUNS_SUCCESS = "EDIT_DETAILS.SAVE_PRONOUNS_SUCCESS";
export const SAVE_PRONOUNS_FAILURE = "EDIT_DETAILS.SAVE_PRONOUNS_FAILURE";
export const CLEAR_PROFILE_LINK = "EDIT_DETAILS.CLEAR_PROFILE_LINK";


// initial state
// -----------------------------------------------------------------------------

export const INITIAL_STATE = {
	isSaving: false,
	activeForm: null,
	errors: {},
	usernameResults: [],
	validUsernames: {},
};

const getInitialState = () => {
	const windowParams = get(window, "__PROFILE_EDIT_PARAMS__.edit_details.data", {});

	return {
		...INITIAL_STATE,
		...windowParams,
	};
};


// reducer
// -----------------------------------------------------------------------------

export const reducer = (state = getInitialState(), action) => {
	switch (action.type) {
		case SET_INITIAL_STATE: {
			const data = get(action.payload, "edit_details", {});
			const pets2 = (get(data, "api_values.pets2") || []).map((v) => `${v}`);
			set(data, "api_values.pets2", pets2);

			if (data.sentence && data.sentence.sentence) {
				data.sentence = data.sentence.sentence;
			}

			return {
				...state,
				...data,
				hasLoadedProfileEditData: true,
			};
		}

		case SET_ACTIVE_FORM: {
			return {
				...state,
				activeForm: action.payload.activeForm,
			};
		}

		case CANCEL_ACTIVE_FORM: {
			return {
				...state,
				activeForm: null,
			};
		}

		case SAVE_FORM: {
			let apiVals = action.payload.values;

			if (apiVals.values) {
				apiVals = apiVals.values;
			}

			return {
				...state,
				isSaving: true,
				api_values: {
					...state.api_values,
					...apiVals,
				},
			};
		}

		case SAVE_FORM_SUCCESS: {
			let gayPrivacy = state.gay_privacy;
			let values = { ...state.values };
			let apiValues = { ...state.api_values };
			const user = action.payload.user;

			if (user) {
				if (user.details) {
					values = {
						...values,
						...user.details.values,
					};
					apiValues = {
						...apiValues,
						...user.details.api_values,
					};
				}

				if (user.settings_privacy) {
					gayPrivacy = action.payload.user.settings_privacy.gayPrivacy;
				}
			}

			return {
				...state,
				values,
				api_values: apiValues,
				gay_privacy: gayPrivacy,
				activeForm: null,
				isSaving: false,
			};
		}

		case SAVE_FORM_ERROR: {
			let error = _str("Something went wrong saving your details! Refresh and try again.");

			if (get(action.payload, "error.message")) {
				error = get(action.payload, "error.message");
			} else if (get(action.payload, "error.error.message")) {
				error = get(action.payload, "error.error.message");
			}

			return {
				...state,
				isSaving: false,
				api_values: {
					...state.api_values,
					...action.payload.values,
				},
				errors: {
					...state.errors,
					[state.activeForm]: error,
				},
			};
		}

		case SAVE_PRONOUNS: {
			return {
				...state,
				isSaving: true,
			};
		}

		case SAVE_PRONOUNS_SUCCESS: {
			let pronouns = action.payload.pronouns;
			let pronounsSentence;

			if (pronouns === "—" || !pronouns) {
				pronouns = false;
				pronounsSentence = false;
			} else {
				pronounsSentence = _strf("Uses $pronouns pronouns", {
					pronouns: pronouns.toLowerCase(),
				});
			}

			return {
				...state,
				isSaving: false,
				activeForm: null,
				values: {
					...state.values,
					pronouns: pronounsSentence,
				},
				api_values: {
					...state.api_values,
					pronouns,
				},
			};
		}

		case SAVE_PRONOUNS_FAILURE: {
			let error;

			if (action.payload.error && action.payload.error.message) {
				error = action.payload.error.message;
			}

			return {
				...state,
				isSaving: false,
				errors: {
					...state.errors,
					[state.activeForm]: error,
				},
			};
		}

		case USERNAME_SEARCH: {
			return {
				...state,
				isUsernameSearching: true,
				usernameResults: [],
			};
		}

		case USERNAME_SEARCH_SUCCESS: {
			const validUsernames = { ...state.validUsernames };
			const usernameResults = [];

			action.payload.res.forEach((user) => {
				if (user.id !== state.user.id) {
					validUsernames[user.username] = user.id;
					usernameResults.push(user);
				}
			});

			return {
				...state,
				isUsernameSearching: false,
				usernameResults,
				validUsernames,
			};
		}

		case USERNAME_SEARCH_ERROR: {
			return {
				...state,
				isUsernameSearching: false,
				usernameResults: [],
			};
		}

		case CLEAR_PROFILE_LINK: {
			return {
				...state,
				linked_account: null,
			};
		}

		default: {
			return state;
		}
	}
};


// action exporters
// -----------------------------------------------------------------------------

export const setInitialState = (payload) => {
	return {
		type: SET_INITIAL_STATE,
		payload,
	};
};

export const setActiveForm = (activeForm) => {
	return {
		type: SET_ACTIVE_FORM,
		payload: { activeForm },
	};
};

export const cancelActiveForm = () => {
	return { type: CANCEL_ACTIVE_FORM };
};

export const saveForm = (values) => {
	return (dispatch) => {
		dispatch({
			type: SAVE_FORM,
			payload: {
				values,
			},
		});

		Api.saveForm(values)
			.then((res) => {
				dispatch({
					type: SAVE_FORM_SUCCESS,
					payload: {
						user: res.user,
					},
				});
			})
			.catch((error) => {
				dispatch({
					type: SAVE_FORM_ERROR,
					error: true,
					payload: { error },
				});
			});
	};
};

export const savePronouns = (values) => {
	return (dispatch) => {
		dispatch({ type: SAVE_PRONOUNS });

		Api.savePronouns(values)
			.then(() => {
				dispatch({
					type: SAVE_PRONOUNS_SUCCESS,
					payload: {
						...values,
					},
				});
			})
			.catch((error) => {
				dispatch({
					type: SAVE_PRONOUNS_FAILURE,
					error: true,
					payload: { error },
				});
			});
	};
};

export const usernameSearch = (username) => {
	return (dispatch) => {
		dispatch({ type: USERNAME_SEARCH });

		Api.usernameSearch(username)
			.then((res) => {
				dispatch({
					type: USERNAME_SEARCH_SUCCESS,
					payload: {
						res,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: USERNAME_SEARCH_ERROR,
					payload: {
						error: true,
					},
				});
			});
	};
};

export const clearProfileLink = () => {
	return { type: CLEAR_PROFILE_LINK };
};



// WEBPACK FOOTER //
// ./src/ducks/edit_details.js